<template>
  <div
    class="__badge"
    :class="[`badge-${type}`, { rounded: rounded, 'letter-space': letterSpacing }]"
  >
    <template v-if="tooltipMsg">
      <el-tooltip class="item" effect="dark" :content="tooltipMsg" placement="bottom">
        <span>
          <Icon :name="icon" :type="iconType" v-if="icon" />
          {{ value }}
        </span>
      </el-tooltip>
    </template>

    <template v-else>
      <Icon :name="icon" :type="iconType" v-if="icon" />
      {{ value }}
    </template>
  </div>
</template>

<script>
import Icon from './Icon';
export default {
  name: 'Badge',
  components: { Icon },
  props: {
    value: [String, Number],
    type: { type: String, default: 'default' },
    rounded: { type: Boolean, default: true },
    icon: String,
    iconType: { type: String, default: 'fas' },
    tooltipMsg: String,
  },
  computed: {
    letterSpacing() {
      if (this.value) {
        return this.value.length < 3;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/mo-custom';

.__badge {
  min-width: 35px;
  margin-left: 10px;
  padding: 2px 5px;
  text-align: center;
  font-size: 0.72em;
  font-weight: 500;

  &.rounded {
    border-radius: 0.25rem;
  }

  &.letter-space {
    letter-spacing: 0.3em;
  }

  &.badge-default {
    background-color: $neutral-color;
    color: $foundation-color;
  }

  &.badge-primary {
    background-color: $primary-color;
    color: $foundation-color;
  }

  &.badge-info {
    background-color: $info-color;
    color: $foundation-color;
  }

  &.badge-success {
    background-color: $success-color;
    color: $foundation-color;
  }

  &.badge-warning {
    background-color: $warning-color;
    color: $foundation-color;
  }

  &.badge-danger {
    background-color: $danger-color;
    color: $foundation-color;
  }
}
</style>
